import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import corner4 from 'assets/img/illustrations/authentication-corner.png';
import Background from 'components/common/Background';
import { UploadPhoto } from 'components/common/UploadPhoto';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { Card, Col, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { getCollabById, uploadProfilePicture } from 'redux/colabsSlice';
import messageHandler from 'utils/messageHandler';
import { getImageUrl } from 'utils/imageUrl';

export const UserCard = ({ user, userLogged }) => {
  const dispatch = useDispatch();

  const handleUploadImage = async file => {
    const newImage = file;

    let formData = new FormData();
    formData.append('photo', newImage);

    try {
      const response = await dispatch(uploadProfilePicture(user?.id, formData));
      if (response?.status === 200) {
        messageHandler('success', 'Foto de perfil actualizada correctamente.');
        await dispatch(getCollabById(user?.id));
      }
    } catch (e) {
      console.log(e);
      messageHandler(
        'error',
        'Hubo un error cargando la imágen. Por favor, intente nuevamente.'
      );
    }
  };

  return (
    <Card
      className="mb-3 bg-100"
      style={{
        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        overflow: 'hidden'
      }}
    >
      <Background
        image={corner4}
        className="bg-card"
        style={{
          borderTopRightRadius: '0rem',
          borderBottomRightRadius: '0rem'
        }}
      />
      <Card.Body className="p-0 position-relative">
        <Row className="g-0">
          <Col xs={12} sm={6} md={6} lg={5} className="p-3">
            {!user?.photo ? (
              <div className="rounded w-100 h-100 bg-secondary p-2 d-flex justify-content-center align-items-center position-relative">
                <div
                  style={{ overflow: 'hidden' }}
                  className="d-flex justify-content-center align-items-center"
                >
                  <FontAwesomeIcon
                    icon={['fas', 'user']}
                    className="text-white"
                    size="7x"
                  />
                </div>

                {user?.id === userLogged?.id && (
                  <UploadPhoto handleUploadImage={handleUploadImage} />
                )}
              </div>
            ) : (
              <div className="w-100 h-100 position-relative">
                <img
                  src={getImageUrl(user.photo, 'users', user.id)}
                  alt="userAvatar"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center'
                  }}
                  className="rounded"
                />

                {user?.id === userLogged?.id && (
                  <UploadPhoto handleUploadImage={handleUploadImage} />
                )}
              </div>
            )}
          </Col>

          <Col xs={12} sm={6} md={6} lg={7} className="py-3">
            <ListGroup variant="flush" className="fw-light small">
              <ListGroupItem className="bg-transparent">
                <p className="m-0">
                  <strong>Nombre:</strong> {user?.firstName}
                </p>
              </ListGroupItem>
              <ListGroupItem className="bg-transparent">
                <p className="m-0">
                  <strong>Apellido:</strong> {user?.lastName}
                </p>
              </ListGroupItem>
              <ListGroupItem className="bg-transparent">
                <p className="m-0">
                  <strong>DNI:</strong> {user?.dni}
                </p>
              </ListGroupItem>
              <ListGroupItem className="bg-transparent">
                <p className="m-0">
                  <strong>Email:</strong> {user?.email}
                </p>
              </ListGroupItem>
              <ListGroupItem className="bg-transparent">
                <p className="m-0">
                  <strong>Teléfono:</strong> {user?.phoneNumber || '-'}
                </p>
              </ListGroupItem>
              <ListGroupItem className="bg-transparent">
                <p className="m-0">
                  <strong>Fecha de Creación:</strong>{' '}
                  {user?.created_at
                    ? dayjs(user?.created_at).format('DD/MM/YYYY')
                    : '-'}
                </p>
              </ListGroupItem>
            </ListGroup>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
UserCard.propTypes = {
  user: PropTypes.object,
  userLogged: PropTypes.object
};
